import React from 'react';
import { FormattedMessage } from 'react-intl';
import isEmpty from 'lodash/isEmpty';

import { Message, Attachment } from 'models';
import MessageWithLinks from 'shared/components/MessageWithLinks';
import messages from '../ChatMessageForCustomer/messages';
import * as helpers from '../ChatMessageForCustomer/helpers';

const ChatMessageWithAttachment = ({ attachment, className, message, style }) => {
  if (isEmpty(attachment)) return null;

  if (!attachment.preview) {
    return (
      <div className={`${className} kustomer-app-thread-customer-message`} style={style}>
        <MessageWithLinks text={message.body} />
        <div className="kustomer-app-customer-message-attachment-loading">
          <FormattedMessage {...messages.loading_attachment} />
        </div>
      </div>
    );
  }

  if (helpers.isSupportedImage(attachment)) {
    return (
      <div className={`${className} kustomer-app-thread-customer-message`} style={style}>
        <MessageWithLinks text={message.body} />
        <div>
          <img src={attachment.preview} alt={attachment.name} />
        </div>
      </div>
    );
  }

  return (
    <div className={`${className} kustomer-app-thread-customer-message`} style={style}>
      <MessageWithLinks text={message.body} />
      <div>
        <a href={attachment.preview}>{attachment.name}</a>
      </div>
    </div>
  );
};

ChatMessageWithAttachment.propTypes = {
  attachment: React.PropTypes.instanceOf(Attachment),
  className: React.PropTypes.String,
  message: React.PropTypes.instanceOf(Message),
  style: React.PropTypes.style,
};

export default ChatMessageWithAttachment;
